export default "__VITE_ASSET__COS0hv3A__"